import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSalaryActivityPerformanceInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSalaryActivityPerformanceInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceInfo/exportByPage',
    method: 'post',
    data
  })
}

// 合计
export function sumSalaryActivityPerformanceInfoListDataApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceInfo/sumByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewSalaryActivityPerformanceInfoApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceInfo/view',
    method: 'post',
    data
  })
}

// 操作
export function saveSalaryActivityPerformanceInfoApi(data) {
  return request({
    url: 'tms-web/salaryActivityPerformanceInfo/save',
    method: 'post',
    data
  })
}

